import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { EditorialMarquee } from "../components/Marquee";
import { Services } from "../components/Services";
import { DieselSection } from "../components/DieselSection";
import { DiagnosticsSection } from "../components/DiagnosticsSection";
import { WhyUs } from "../components/WhyUs";
import { VehicleTypes } from "../components/VehicleTypes";
import { Reviews } from "../components/Reviews";
import { Faq } from "../components/Faq";
import { RequestForm } from "../components/RequestForm";
import { ContactSection } from "../components/ContactSection";
import { Footer } from "../components/Footer";
import { MobileCta } from "../components/MobileCta";

export default function Home() {
  return (
    <div className="bg-[#0A0A0A] text-white" data-testid="home-page">
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <Services />
        <DieselSection />
        <DiagnosticsSection />
        <WhyUs />
        <VehicleTypes />
        <Reviews />
        <Faq />
        <RequestForm />
        <ContactSection />
      </main>
      <div className="pb-[57px] lg:pb-0">
        <Footer />
      </div>
      <MobileCta />
    </div>
  );
}
